











































import { Ref, Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { Branch } from '@/api/model/branch'
import { Company } from '@/api/model/company'
import { ProviderInstance } from 'vee-validate/dist/types/types'

@Component
export default class InputSelectBranch extends Vue {
    @Ref() validator!: ProviderInstance
    @Prop({ default: null }) readonly rules!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly placeholder!: string
    @Prop() readonly branches!: Branch[]
    @Prop() readonly value!: Branch
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    @Prop({ type: Boolean, default: false }) readonly clearable!: boolean
    @Prop({ type: Boolean, default: false }) readonly white!: boolean
    internalValue: Branch = null
    showOptions: boolean = false
    search: string = ''

    created() {
        this.internalValue = this.value
        window.addEventListener('click', this.onOutsideClick)
    }

    beforeDestroy() {
        window.removeEventListener('click', this.onOutsideClick)
    }

    @Watch('branches')
    onBranchesChanged() {
        if (this.internalValue && !this.branches.some((branch: Branch) => branch.id === this.internalValue.id)) {
            this.internalValue = null
        }
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.value
    }

    @Watch('internalValue')
    async onInput(): Promise<void> {
        await this.validator.validate(this.internalValue)
        this.$emit('input', this.internalValue)
    }

    applyClass(option: Branch) {
        if (this.value && this.value.id === option.id) {
            return ['input-select__option--selected']
        }

        return []
    }

    toggleOptions(): void {
        if (!this.disabled) {
            this.showOptions = !this.showOptions

            // Give search input focus on open.
            if (this.showOptions) {
                this.search = null
                this.$nextTick(() => this.$el
                    .getElementsByClassName('search')[0]
                    .getElementsByTagName('input')[0]
                    .focus())
            }
        }
    }

    selectOption(option: Branch): void {
        this.internalValue = option
        this.showOptions = false
    }

    get isClearable(): boolean {
        return this.clearable && this.internalValue !== null && !this.disabled
    }

    clear(): void {
        this.internalValue = null
        this.showOptions = false
    }

    get selectedOption() {
        if (!this.value) {
            return null
        }
        return this.branches.find(value => value.id === this.value.id)
    }

    get componentClass(): object {
        return {
            'input-select-branch': true,
            'input-select': true,
            'input-select--disabled': this.disabled,
            'input-select--white': this.white,
            'opened': this.showOptions,
        }
    }

    get filteredBranches(): Branch[] {
        if (!this.search || this.search.length === 0) {
            return this.branches
        }

        return this.branches.filter(branch => branch.name.toLowerCase().includes(this.search.toLowerCase()))
    }

    isCurrentCompany(company: Company): boolean {
        return this.$currentCompany.id === company.id
    }

    async onOutsideClick(e: Event) {
        const target = e.target as HTMLDivElement

        if (!this.$el.contains(target)) {
            this.showOptions = false
        }
    }
}
